export default __webpack_public_path__ + "static/bg-968b83915f389bd378c0e35faa87faea.jpg";